// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"370":"5fb83f1e","488":"1a75ff5b","785":"21bb74fb"}[chunkId] + ".chunk.js";
};